import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

/**
 * Componente per visualizzare un grafico a barre dei contratti per anno.
 * @param {object} props - Le props del componente.
 * @param {Array<object>} props.data - L'array di dati da visualizzare. Ogni oggetto deve avere 'year' e 'count'.
 */
const ContractsByYearChart = ({ data }) => {
    // Se non ci sono dati, mostra un messaggio
    if (!data || data.length === 0) {
        return <p>Nessun dato disponibile per visualizzare il grafico.</p>;
    }

    return (
        // ResponsiveContainer permette al grafico di adattarsi alle dimensioni del contenitore
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                data={data}
                margin={{
                    top: 20,
                    right: 30,
                    left: 0,
                    bottom: 5,
                }}
            >
                {/* Griglia di sfondo del grafico */}
                <CartesianGrid strokeDasharray="3 3" />

                {/* Asse X (orizzontale), che usa la chiave 'year' dai dati */}
                <XAxis dataKey="year" />

                {/* Asse Y (verticale), che mostra il conteggio. 'allowDecimals={false}' impedisce numeri con la virgola come 2.5 */}
                <YAxis allowDecimals={false} />

                {/* Tooltip che appare quando passi il mouse sopra una barra */}
                <Tooltip />

                {/* Legenda in basso */}
                <Legend />

                {/* La barra vera e propria. 'dataKey="count"' dice al grafico quale valore usare per l'altezza della barra. */}
                <Bar dataKey="count" name="Numero Contratti" fill="#8884d8" />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default ContractsByYearChart;